import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19838 19838"
    {...props}
  >
    <path
      d="M8282 8821C6990 9797 4633 9856 283 9919c4350 63 6707 122 7999 1098-476 921-1519 2010-3132 3671 1661-1614 2750-2656 3670-3132 977 1292 1036 3649 1099 7999 63-4350 122-6707 1099-7999 921 476 2009 1518 3670 3132-1613-1661-2656-2750-3132-3671 1292-976 3649-1035 7999-1098-4350-63-6707-122-7999-1098 476-921 1519-2010 3132-3671-1661 1614-2749 2656-3670 3132-977-1292-1036-3649-1099-7999-63 4350-122 6707-1099 7999-920-476-2009-1518-3670-3132 1613 1661 2656 2750 3132 3671z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 566.802,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
